var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_1535)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.0625,
    y: 2.0625,
    width: 29.1328,
    height: 28.7461,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1173 28.1179H23.2278V20.4605C23.2278 18.6345 23.1951 16.2839 20.6847 16.2839C18.138 16.2839 17.7483 18.2734 17.7483 20.3276V28.1174H12.8589V12.3707H17.5528V14.5227H17.6185C18.0883 13.7195 18.7671 13.0587 19.5827 12.6107C20.3982 12.1628 21.32 11.9445 22.2499 11.979C27.2057 11.979 28.1194 15.2387 28.1194 19.4795L28.1173 28.1179ZM7.34174 10.2184C5.77463 10.2186 4.504 8.94837 4.50374 7.38126C4.50348 5.81415 5.7736 4.54352 7.34071 4.54326C8.90782 4.54287 10.1785 5.81312 10.1787 7.38023C10.1788 8.13279 9.88003 8.85458 9.348 9.38683C8.81597 9.91908 8.0943 10.2182 7.34174 10.2184ZM9.78658 28.118H4.89188V12.3707H9.78645V28.1179L9.78658 28.118ZM30.5549 0.0022797H2.43492C1.1059 -0.0126734 0.015998 1.05196 -0.000244141 2.38099V30.6183C0.0154824 31.948 1.10526 33.0136 2.43479 32.9997H30.5549C31.8873 33.0162 32.9813 31.9505 32.9998 30.6183V2.3788C32.9808 1.04719 31.8867 -0.0173141 30.5549 8.82908e-05",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_1535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.723aea32d447fcbca2557828b588949a.svg";
export { ForwardRef as ReactComponent };